import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			folio:"",
			date:"",
			hour:"",
			user:"",
			details:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
		
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'supplies_discards/'+id,{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					show: true,
					folio:response.folio,
					date:response.date !== "" ? response.date.split('T')[0] : "",
					hour:response.hour !== "" ?  moment(response.hour, 'H:mm:ss').format('HH:mm') : "",
					user:response.user,
					details:response.details
				});
			}
		})
	
	}

	handleClose(){
		this.setState({
			show: false,
			folio:"",
			date:"",
			hour:"",
			user:"",
			details:[],
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Baja</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">

		        		<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-2">
								<span>Folio</span>
								<input type="text" name="folio" id="folio" value={this.state.folio} 
									className="form-control" disabled />
							</div>
							<div className="col-xs-12 col-sm-3">
								<span>Fecha</span>
								<input type="date" name="date" id="date" value={this.state.date} disabled
									className="form-control hour-input" />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span>Fecha</span>
								<input type="time" name="hour" id="hour" value={this.state.hour} disabled
									className="form-control input-hour" />
							</div>
							<div className="col-xs-12 col-sm-5">
								<span>Usuario</span>
								<input type="text" name="user" id="user" value={this.state.user} 
									className="form-control" disabled />
							</div>
						</div>

		        		
		        		<div className="col-xs-12">
							<Table  hover>
								<thead>
									<tr>
										<th>Insumo</th>
										<th>Lote</th>
										<th>Cantidad</th>
										<th>Caductidad</th>
										<th>Motivo</th>
									</tr>
								</thead>
								<tbody>
									{this.state.details.map((l, i)=>(
										<tr key={i}>
											<td>{l.product_name}</td>
											<td>{l.lot_number}</td>
											<td>{l.amount}</td>
											<td>{moment(l.expiration_date).format('DD/MM/YYYY')}</td>
											<td>{l.reason}</td>
										</tr>
									))}
								</tbody>
							</Table>
						</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
} 

export default translate('translations') (ModalDetails);